import React, { PropsWithChildren, useCallback, useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { KeyboardAvoidingView, Platform, RefreshControl, ScrollView, ViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { setData } from '@/state/user';

interface Props extends ViewProps {
  center?: boolean,
  overrideStyle?: boolean,
};

export function BasicWrapperView({ center = false, overrideStyle = false, style, children, ...props }: PropsWithChildren<Props>) : React.ReactNode {
  const domain = useSelector((state: RootState) => state.user.domain);
  const isMainLogicalHost = useSelector((state: RootState) => state.user.isMainLogicalHost);

  const styles: StyleProp<ViewStyle>[] = [center ? AppConstants.STYLES.basicWrapperViewCenter : AppConstants.STYLES.basicWrapperView];
  if (style) {
    if (!overrideStyle) {
      styles.push(style);
    } else {
      styles.splice(0, styles.length);
      styles.push(style);
    }
  }

  return (
    <View
      style={styles}
      {...props}
    >
      {children}
    </View>
  );
};
